var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgGroupMail = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30.75,
    height: 30.815,
    viewBox: "0 0 30.75 30.815",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1699",
    "data-name": "Group 1699",
    transform: "translate(-635.6 -308)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "np_invite_3139227_000000",
    transform: "translate(635.6 308)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5683",
    "data-name": "Path 5683",
    d: "M28.032,9.994V2.5H7.921V9.994L2.6,13.756v19.56h30.75V13.756Zm2.5,4.281-2.5,1.784V12.523Zm-4.573-9.7V17.517l-7.98,5.645L10,17.518V4.576ZM7.921,16.059l-2.5-1.784,2.5-1.784ZM4.677,31.24V16.286l13.3,9.407,13.3-9.407V31.271H4.677Z",
    transform: "translate(-2.602 -2.5)",
    fill: "#725d7b"
  })), /*#__PURE__*/React.createElement("path", {
    id: "beatBread_logo",
    "data-name": "beatBread logo",
    d: "M2.939,8.686H0V-.008H1.6V5.717h0s0,0,0,0A1.062,1.062,0,1,0,2.662,4.639a1.042,1.042,0,0,0-.637.217V-.008H3.054a1.975,1.975,0,0,1,1.954,2A2.009,2.009,0,0,1,4.35,3.481a2.812,2.812,0,0,1,1.333,2.4A2.773,2.773,0,0,1,2.939,8.686Z",
    transform: "translate(648.458 313.644)",
    fill: "#725d7b"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGroupMail, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/GroupMail.adac0d58.svg";
export { ForwardRef as ReactComponent };